module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMGJkYjc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY19wZW5fZ3JlZW48L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjAgMTIuNzEgMCAxNiAzLjI5IDE2IDEzLjE2IDYuMTMgOS43OCAyLjc2IDAgMTIuNzEiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNS43MywzLjU2YS44Ni44NiwwLDAsMCwwLTEuMjJsMCwwLTItMmEuODYuODYsMCwwLDAtMS4yMiwwbDAsMC0xLjYsMS42LDMuMjksMy4zN1oiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_pen_green.svg
// module id = eren
// module chunks = 1